import { Stack, Typography } from "@mui/material";
import { Address, PhoneInputV2, StackGrid, TextFieldForm } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { TPartnerFeedbackFormResolver } from "./resolver";

interface IPartnerFeedbackInfosFormProps {
  control: Control<TPartnerFeedbackFormResolver>;
}

export const PartnerFeedbackInfosForm = ({ control }: IPartnerFeedbackInfosFormProps) => {
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="h4" color="primary">
        Retour du partenaire
      </Typography>
      <StackGrid perLine={{ tablet: 3 }} gap={2}>
        <TextFieldForm
          size="small"
          control={control}
          name="partnerFeedback.accompanierName"
          label="Prénom, Nom de l'accompagnateur *"
          fullWidth
        />
      </StackGrid>
      <StackGrid perLine={{ tablet: 3 }} gap={2}>
        <TextFieldForm
          size="small"
          control={control}
          name="partnerFeedback.name"
          label="Nom du partenaire *"
          fullWidth
        />
        <TextFieldForm size="small" control={control} name="partnerFeedback.email" label="Email" fullWidth />
        <Controller
          control={control}
          name="partnerFeedback.phone"
          render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
            <PhoneInputV2
              id="cer-phone"
              inputRef={ref}
              label="Téléphone"
              value={value ?? ""}
              onChange={onChange}
              size="small"
              error={!!error}
              helperText={error?.message}
              fullWidth
            />
          )}
        />
      </StackGrid>
      <Controller
        control={control}
        name="partnerFeedback.address"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Address
            label="Adresse du partenaire"
            value={value ?? null}
            onChange={(_, v) => onChange({ target: { value: v } })}
            size="small"
            TextFieldProps={{ error: Boolean(error), helperText: error?.message }}
          />
        )}
      />
    </Stack>
  );
};
